module.exports = __webpack_public_path__ + "img/gmailLogo.84080917.svg";